export default "__VITE_ASSET__f146c2ec__"